
import actions from './actions'
import mutations from './mutations'

let state = {
    all: null,
    count: 0,
    current: null,
    page: 1
}

const ACTIONS = {
    GET: 'echeanciers/get',
    GET_ALL: 'echeanciers/getAll',
    GET_NEXT: 'echeanciers/getNext'
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}

export { ACTIONS as actions }